<template>
  <v-dialog
    v-model="loader.loading"
    persistent
    width="300"
  >
    <v-card
      color="primary"
      dark
    >
      <v-card-text>
        <!-- <p v-html="$t('Common.loading')"/> -->
        <p v-html="loader.text" />
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['loader'])
  }
}
</script>

<style>

</style>
